
import { state, switchToView, getSpreadsheetLink } from "@/store";
import { defineComponent, computed, watch, ref } from "vue";
import { useRoute } from "vue-router/composables";
export default defineComponent({
  setup(props, context) {
    const route = useRoute();
    const isProjectRoute = computed(() => route.path.includes("/project"));

    return {
      state,
      switchToView,
      getSpreadsheetLink,
      isProjectRoute,
      route,
    };
  },

  // data: () => ({
  //   state,
  // }),
  // methods: {
  //   switchToView,
  //   getSpreadsheetLink,
  // },
  // computed: {
  //   isProjectRoute: function () {
  //     return this.$route.path.includes("/project");
  //   },
  // },
});
